import { ReportPrinter } from "./ReportPrinter";
import { PageData } from "./usePrintJourneyListData";

export function printSerialNumber(printer: ReportPrinter, page: PageData) {
  printer.setFont("slab-light", 28, 1);
  printer.printTextExt(
    "ПЪТЕН ЛИСТ",
    printer.pageMarginX + printer.printableWidth / 2,
    122,
    printer.printableWidth,
    { align: "center" }
  );

  printer.setFont("slab-light", 15, 1);
  printer.printSpace(-4);
  printer.printText(
    `СЕРИЯ:  ${page.depotText}  №  ${page.serialNumber}`,
    printer.pageMarginX + printer.printableWidth / 2,
    printer.printableWidth,
    { align: "center" }
  );

  printer.printSpace(-5);
}
